import { api, get, post } from '@/lib/api';

const RAIZ = '/catalog';

export type ServiceType = 'BUSINESS' | 'TECHNICAL';
export type PortfolioStage = 'PIPELINE' | 'CATALOGUE' | 'RETIRED';
export type Criticality = 'LOW' | 'MEDIUM' | 'HIGH' | 'CRITICAL';
export type ComponentCriticality = 'REQUIRED' | 'REDUNDANT' | 'AUXILIARY';

export interface ServiceCatalogItem {
  id: string;
  key: string;
  name: string;
  description: string | null;
  serviceType: ServiceType;
  portfolioStage: PortfolioStage;
  criticality: Criticality;
  active: boolean;
  createdAt: string;
  updatedAt: string;
  version: number;
}

export interface ServiceComponent {
  id: string;
  serviceId: string;
  ciId: string;
  criticality: ComponentCriticality;
  note: string | null;
  ci: { id: string; name: string; ciType: string; lifecycleStatus: string };
}

export interface CreateServiceDto {
  key: string;
  name: string;
  description?: string;
  serviceType?: ServiceType;
  portfolioStage?: PortfolioStage;
  criticality?: Criticality;
}

export interface UpdateServiceDto {
  name?: string;
  description?: string;
  portfolioStage?: PortfolioStage;
  criticality?: Criticality;
  active?: boolean;
}

export function listarServicos(type?: ServiceType, stage?: PortfolioStage): Promise<ServiceCatalogItem[]> {
  const params = new URLSearchParams();
  if (type) params.set('type', type);
  if (stage) params.set('stage', stage);
  const qs = params.toString();
  return get<ServiceCatalogItem[]>(`${RAIZ}/services/all${qs ? `?${qs}` : ''}`);
}

export function criarServico(dto: CreateServiceDto): Promise<ServiceCatalogItem> {
  return post<ServiceCatalogItem>(`${RAIZ}/services`, dto);
}

export function atualizarServico(id: string, dto: UpdateServiceDto): Promise<ServiceCatalogItem> {
  return api<ServiceCatalogItem>(`${RAIZ}/services/${id}`, { method: 'PATCH', body: dto });
}

export function excluirServico(id: string): Promise<void> {
  return api<void>(`${RAIZ}/services/${id}`, { method: 'DELETE' });
}

export function listarComponentes(serviceId: string): Promise<ServiceComponent[]> {
  return get<ServiceComponent[]>(`${RAIZ}/services/${serviceId}/components`);
}

export const chavesCatalogo = {
  lista: (type?: ServiceType, stage?: PortfolioStage) => ['catalogo', 'lista', type, stage] as const,
  componentes: (id: string) => ['catalogo', 'componentes', id] as const,
};
